import React from "react";
import "../../css/aboutMe.css";

class OriginStory extends React.Component {
  render() {
    return (
      <div className="origin-story">
        <h2 className="origin-title">🗺️ Origin Story</h2>

        <div className="year-block">
          <h4>2022</h4>
          <ul>
            <li>
              Began MSc (Tech) in Information Security at Tampere University,
              with a minor in Human–Technology Interaction.
            </li>
            <li>
              Launched the first version of{" "}
              <a href="https://ibtehaz.xyz" target="_blank" rel="noreferrer">
                ibtehaz.xyz
              </a>
              .
            </li>
          </ul>
        </div>

        <div className="year-block">
          <h4>2023</h4>
          <ul>
            <li>
              Completed summer internship at HUBS, exploring entrepreneurship
              and innovation.
            </li>
          </ul>
        </div>

        <div className="year-block">
          <h4>
            2024 – <span className="highlight">A Year of Exploration</span>
          </h4>
          <ul>
            <li>
              ECIU Challenge (Lithuania, Feb–June) with KTU & LitGrid: hands-on
              energy sector project
            </li>
            <li>
              Summer semester at University of Giessen: studied open data,
              climate models, Byzantine art, peacebuilding, and human rights
            </li>
            <li>
              Sprint Innovation Festival (HUBS) + GEM Workshop: designed a data
              viz from receipts found in trash
            </li>
            <li>
              Joined OASIS as Research Assistant: co-authored a conference
              paper, working on a journal paper
            </li>
            <li>
              Completed <em>Google Data Analytics</em> (July) and{" "}
              <em>Intro to Data Science with Python</em> (Aug)
            </li>
            <li>
              Prototyping seminars, DigitAInability Winter School, and a 3-day
              3D design workshop at TUNI
            </li>
            <li>
              Started Asian Studies minor at University of Turku — courses on
              Mongolia and Chinese history
            </li>
            <li>
              Started revamp of{" "}
              <a href="https://ibtehaz.xyz" target="_blank" rel="noreferrer">
                ibtehaz.xyz
              </a>{" "}
              (Sept)
            </li>
          </ul>
        </div>

        <div className="year-block">
          <h4>
            2025 – <span className="highlight">Building & Shipping</span>
          </h4>
          <ul>
            <li>
              <strong>MetaPriv</strong>: MSc thesis project — a privacy tool for
              Facebook (Jan–Jul)
            </li>
            <li>
              Demola Summer Internship: co-created event experience solutions
              for live events
            </li>
            <li>
              Superwider: working part-time as a full-stack developer (Next.js /
              TypeScript)
            </li>
            <li>
              Platform6 Digithon: designed solutions for member retention (Feb)
            </li>
            <li>
              ECIU Hackathon: built <strong>OLA</strong>, an AI agent with
              ChatGPT to guide students in ECIU opportunities
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default OriginStory;
